export const checkExcludingBannerByRoutes = (
  excludeRoutes: string[],
  pathname: string
) => {
  return excludeRoutes.some(pattern => {
    const escaped = pattern.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
    const regex = new RegExp(escaped.replace(/\\\*/g, ".*"))

    return regex.test(pathname)
  })
}
